import { Card } from "react-bootstrap";
import PropTypes from "prop-types";

import PasswordStrengthRule from "./PasswordStrengthRule";

const PasswordStrengthCard = ({ password }) => {

	const passwordStatus = [
		{
			id: "length",
			label: "Between 8 - 32 characters",
			passing: password?.length > 8 && password.length < 32
		},
		{
			id: "uppercase",
			label: "At least one uppercase letter",
			passing: !!password && password?.toLowerCase() !== password
		},
		{
			id: "lowercase",
			label: "At least one lowercase letter",
			passing: !!password && password?.toUpperCase() !== password
		},
		{
			id: "number",
			label: "At least one number",
			passing: (/\d/u).test(password)
		},
		{
			id: "special",
			label: "At least one special character",
			passing: (/[\s~`!@#$%^&*+=\-[\]\\';,/{}|\\":<>?()._]/gu).test(password)
		}
	];

	return (
		<Card>
			<Card.Body>
				{passwordStatus.map((rule) => <PasswordStrengthRule key={rule.id} label={rule.label} passing={rule.passing} password={password} />)}
			</Card.Body>
		</Card>
	);

};

PasswordStrengthCard.propTypes = {
	password: PropTypes.string
};

PasswordStrengthCard.defaultProps = {
	password: ""
};

export default PasswordStrengthCard;
